import {Box, Typography} from "@mui/material";
import React from "react";
import bronze from "../../assets/bronze.png";

export default function InsuranceBronze(props: any) {
    return (
        <Box
            sx={{
                backgroundImage: 'linear-gradient(to right, #532B00, #C47B2D)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 1,
            }}
        >
            <Box>
                <img
                    src={bronze}
                    alt="Bronze"
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        borderRadius: '50%',
                    }}
                />
            </Box>
            <Typography variant="h4" component="div" sx={{ fontWeight: 'bold', color: 'white' }}>
                BRONZE
            </Typography>
            <Typography variant="body2" color="white">
                Plano de 12 meses
            </Typography>
        </Box>
    )
}